import { useState } from 'react'
import ClassiUtentiService from '../services/ClassiUtentiService/ClassiUtentiService';
import UtilityService from '../services/UtillityServices/UtilityService';
import { alertService } from '../services/AlertService';
import { handleError } from '../model/handleError';

const useClassiUtenti = () => {
    const [loadingState, setLoadingState] = useState({
        isLoadingClassiUtenti: false,
        isLoadingClassiUtenteByToken: false,
        isLoadingClassiUtentiCreating: false,
        isLoadingClassiUtentiDelete: false,
        deleteClassiUtentiByClasseAndUtente: false,
        isLoadingClassiUtenteByUserId: false,
        isLoadingClassiUtentiByParams: false,
        isLoadingUpdateStatoPagamento: false,
        isLoadingFindClassiUtentiByUtente: false
    });

    const [modalState, setModalState] = useState({
        showModalCreateClassiUtenti: false,
        showModalDeleteClassiUtenti: false,
        showModalUpdateClassiUtente: false,
        showModalViewClassiList: false
    });

    const getClassiUtentiByIdClasse = async (data) => {
      setLoadingState({ ...loadingState, isLoadingClassiUtenti: true });
        try {
          let response = await ClassiUtentiService.getClassiUtentiByIdClasse(data);
          if (response) {
            return response;
          } else {
            return [];
          }
        } catch (error) {
          handleError(error);
        } finally {
          setLoadingState({ ...loadingState, isLoadingClassiUtenti: false });
        }
      };

      const getClassiUtenteByToken = async (data) => {
        setLoadingState({ ...loadingState, isLoadingClassiUtenteByToken: true });
          try {
            let response = await ClassiUtentiService.getClassiUtenteByToken(data);
            return response;
          } catch (error) {
            handleError(error);
          } finally {
            setLoadingState({ ...loadingState, isLoadingClassiUtenteByToken: false });
          }
        };

        const getClassiUtenteByUserId = async (data) => {
          setLoadingState({ ...loadingState, isLoadingClassiUtenteByUserId: true });
          try {
            let response = await ClassiUtentiService.getClassiUtenteByUserId(data);
            return response;
          } catch (error) {
            handleError(error);
          } finally {
            setLoadingState({ ...loadingState, isLoadingClassiUtenteByUserId: false });
          }
        }


        const getClassiUtentiByParams = async (data) => {
          setLoadingState({ ...loadingState, isLoadingClassiUtentiByParams: true });
            try {
              let obj;
              let response = await ClassiUtentiService.getClassiUtentiByParams(data);
              const res = await response.json();
              const totalRecord = response.headers.get('X-Total-Record');
              obj = {
                data: res,
                count: totalRecord
              }
              return obj;
            } catch (error) {
              handleError(error);
            } finally {
              setLoadingState({ ...loadingState, isLoadingClassiUtentiByParams: false });
            }
          };

      const createClassiUtenti = async (data, userData) => {
        try {
        setLoadingState({ ...loadingState, isLoadingClassiUtentiCreating: true });
        let response = await ClassiUtentiService.createClassiUtenti(data);
        if(userData) {  
          alertService.success(`${userData?.nome} ${userData?.cognome} assegnato con successo`, {autoClose: true});
        } 
        return response;
      } catch (err) {
        handleError(err, {
          RESOURCE_ALREADY_EXISTS: `${data?.nome} ${data?.cognome} è già iscritto al corso`
        })
      } finally {
        setLoadingState({ ...loadingState, isLoadingClassiUtentiCreating: false });
      }
    }

    const deleteClassiUtentiByClasseAndUtente = async (data, userData) => {
      try {
        setLoadingState({ ...loadingState, deleteClassiUtentiByClasseAndUtente: true });
        let response = await ClassiUtentiService.deleteClassiUtentiByClasseAndUtente(data);
        const res = await response.json();
        alertService.success(`${userData?.nome} ${userData?.cognome} rimosso con successo`, {autoClose: true});
        return res;
      } catch (error) {
        handleError(error);
      } finally {
        setLoadingState({ ...loadingState, deleteClassiUtentiByClasseAndUtente: false });
      }
    }

    const deleteClassiUtenti = async (data, userData) => {
      try {
        setLoadingState({ ...loadingState, isLoadingClassiUtentiDelete: true });
        let response = await ClassiUtentiService.deleteClassiUtenti(data);
        const res = await response.json();
        alertService.success(`${userData?.nome} ${userData?.cognome} rimosso con successo`, {autoClose: true});
        return res;
      } catch (error) {
        handleError(error);
      } finally {
        setLoadingState({ ...loadingState, isLoadingClassiUtentiDelete: false });
      }
    }

    const updateStatoPagamento = async (data) => {
      try {
        setLoadingState({ ...loadingState, isLoadingUpdateStatoPagamento: true });
        let response = await ClassiUtentiService.updateStatoPagamento(data);
        alertService.success(`Stato pagamento aggiornato con successo`, {autoClose: true});
        return response;
      } catch (error) {
        handleError(error);
      } finally {
        setLoadingState({ ...loadingState, isLoadingUpdateStatoPagamento: false });
      }
    }

    const updateCondizioni = async (data) => {//NEW
      try {
        setLoadingState({ ...loadingState, isLoadingUpdateCondizioni: true });
        let response = await ClassiUtentiService.updateCondizioni(data);
        alertService.success(`Salvataggio accettazione condizioni effettuato con successo`, {autoClose: true});
        return response;
      } catch (error) {
        handleError(error);
      } finally {
        setLoadingState({ ...loadingState, isLoadingUpdateCondizioni: false });
      }
    }

    const getCondizioni = async (data) => {//NEW
      try {
        setLoadingState({ ...loadingState, isLoadingGetCondizioni: true });
        let response = await ClassiUtentiService.getCondizioni(data);
        return response;
      } catch (error) {
        handleError(error);
      } finally {
        setLoadingState({ ...loadingState, isLoadingGetCondizioni: false });
      } 
    }

    const findClassiUtentiByUtente = async (data) => {
      try {
        setLoadingState({ ...loadingState, isLoadingFindClassiUtentiByUtente: true });
        let response = await ClassiUtentiService.findClassiUtentiByUtente(data);
        return response;
      } catch (error) {
        handleError(error);
      } finally {
        setLoadingState({ ...loadingState, isLoadingFindClassiUtentiByUtente: false });
      } 
    }

    const updateStatoVerifica = async (data) => {
    // Usiamo uno stato di caricamento generico per l'update
    setLoadingState(state => ({ ...state, isLoadingUpdateStatoPagamento: true }));
    try {
        const response = await ClassiUtentiService.updateStatoVerifica(data);
        alertService.success("Stato di verifica aggiornato con successo!", { autoClose: true });
        return response;
    } catch (err) {
        handleError(err);
    } finally {
        setLoadingState(state => ({ ...state, isLoadingUpdateStatoPagamento: false }));
    }
};

  return {
    loadingStateClassiUtenti: loadingState,
    modalStateClassiUtenti: modalState,
    setModalStateClassiUtenti: setModalState,
    getClassiUtentiByIdClasse,
    getClassiUtenteByToken,
    getClassiUtentiByParams,
    createClassiUtenti,
    deleteClassiUtentiByClasseAndUtente,
    deleteClassiUtenti,
    updateStatoPagamento,
    updateStatoVerifica,
    updateCondizioni,
    getCondizioni,
    findClassiUtentiByUtente,
    getClassiUtenteByUserId
  };      
}

export default useClassiUtenti;